export default "__VITE_ASSET__CYTjha_k__"